import React from "react";
import DatePicker from "react-datepicker";

type Props = {
    startDate: Date | null;
    onChange: (date: Date | null) => void;
};

function BaseDatePicker({ startDate, onChange }: Props) {
    const yearListLength = 50;
    const years = Array.from(
        { length: yearListLength },
        (_, i) => new Date().getFullYear() - (yearListLength - 1) + i
    );
    const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
    ];

    return (
        <DatePicker
            calendarClassName="!absolute top-full z-10"
            selected={startDate}
            onChange={onChange}
            inline
            showYearDropdown
            renderCustomHeader={({
                date,
                changeYear,
                changeMonth,
                decreaseMonth,
                increaseMonth,
                prevMonthButtonDisabled,
                nextMonthButtonDisabled,
            }) => (
                <div className="flex items-center justify-between px-2 pb-1">
                    <button
                        onClick={decreaseMonth}
                        disabled={prevMonthButtonDisabled}
                        className="p-1 bg-white rounded-full hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        <svg
                            className="w-6 h-6 text-gray-600"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M15 19l-7-7 7-7"
                            />
                        </svg>
                    </button>

                    <div className="space-y-0">
                        <select
                            value={date.getMonth()}
                            onChange={({ target: { value } }) =>
                                changeMonth(+value)
                            }
                            className="p-1 text-center text-base bg-transparent focus:ring-blue-500 focus:border-blue-500"
                        >
                            {months.map((month, i) => (
                                <option key={month} value={i}>
                                    {month}
                                </option>
                            ))}
                        </select>

                        <select
                            value={date.getFullYear()}
                            onChange={({ target: { value } }) =>
                                changeYear(+value)
                            }
                            className="p-1 text-base bg-transparent focus:ring-blue-500 focus:border-blue-500"
                        >
                            {years.map((option) => (
                                <option key={option} value={option}>
                                    {option}
                                </option>
                            ))}
                        </select>
                    </div>

                    <button
                        onClick={increaseMonth}
                        disabled={nextMonthButtonDisabled}
                        className="p-1 bg-white rounded-full hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                        <svg
                            className="w-6 h-6 text-gray-600"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M9 5l7 7-7 7"
                            />
                        </svg>
                    </button>
                </div>
            )}
        />
    );
}

export default BaseDatePicker;
